import { KeyValue } from "@/main/models/common";
import { VoucherRefundStatusActionTypes as ActionTypes, VoucherRefundStatusTypes } from "./voucherRefundStatusTypes";

export function getVoucherRefundStatus(): ActionTypes {
	return {
		type: VoucherRefundStatusTypes.GET_VOUCHER_REFUND_STATUS,
	};
}

export function saveVoucherRefundStatus(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): ActionTypes {
	return {
		type: VoucherRefundStatusTypes.SAVE_VOUCHER_REFUND_STATUS,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerVoucherRefundStatus(): ActionTypes {
	return {
		type: VoucherRefundStatusTypes.RESET_REDUCER_VOUCHER_REFUND_STATUS,
	};
}
